import { oembedUrl } from './OembedStore';

import { oembedUrlDefault } from './OembedStoreDefaults';

export const resetOembedUrl = () => {
	oembedUrl.set(oembedUrlDefault);
};
